module.exports = __webpack_public_path__ + "img/30m8.bed84206.jpg";